import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import packkagee from "../package.json";


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={packkagee.name}>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
